import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { WebinarRoomHeaderComponent } from '../../../../sharedLegacy/components'

const Header = ({ children, siteLogo }) => (
  <WebinarRoomHeaderComponent src={siteLogo}>
    {children && children}
  </WebinarRoomHeaderComponent>
)

Header.propTypes = {
  siteLogo: PropTypes.string,
  children: PropTypes.node,
}

const mapStateToProps = (state) => ({
  siteLogo: state.webinar.siteLogo,
})

export default connect(mapStateToProps)(Header)
